import React from "react";
import Button from "../../../../../components/ui/Button/Button";
import { Dropdown } from "../../../../../components/ui/Dropdown/Dropdown";
import InputSearch from "../../../../../components/ui/InputSearch/InputSearch";
import InputDate from "../../../../../components/ui/InputDate/InputDate";

const orderClassFilter = [
  { id: 1, name: "전체" },
  { id: 2, name: "자동(재고)" },
  { id: 3, name: "수동(재고)" },
  { id: 4, name: "수동(원데이몰)" },
];

const stateFilter = [
  { id: 1, name: "전체" },
  { id: 2, name: "교환요청" },
  { id: 3, name: "교환승인" },
  { id: 4, name: "교환거부(구매확정)" },
  { id: 5, name: "교환배송(반송)" },
  { id: 6, name: "교환배송(본사)" },
  { id: 7, name: "교환배송완료(구매확정)" },
];

const OrderExchangeFilter = (props) => {
  const { onChangeSearchBy, options } = props;
  return (
    <div className="-mt-4 flex justify-between bg-input-grey">
      <div className="space-y-3 py-4 pl-6">
        <div className="flex text-[11px] space-x-4 items-center">
          <h1 className="font-bold text-[12px] w-14">주문구분</h1>
          {orderClassFilter.map((item) => (
            <div key={item.id} className="flex items-center">
              <input
                id="orderClass"
                name="orderClass"
                type="radio"
                className="accent-black mr-2"
              />
              <label>{item.name}</label>
            </div>
          ))}
        </div>
        <div className="flex text-[11px] space-x-4 items-center">
          <h1 className="font-bold text-[12px] w-14">상태</h1>
          {stateFilter.map((item) => (
            <div key={item.id} className="flex items-center">
              <input
                id="state"
                name="state"
                type="radio"
                className="accent-black mr-2"
              />
              <label>{item.name}</label>
            </div>
          ))}
        </div>
        <div className="flex text-[11px] space-x-4 items-center">
          <div className="flex items-center space-x-4">
            <h1 className="font-bold text-[12px] w-14">검색</h1>
            <Dropdown
              options={options}
              placeholder={`상품명`}
              backgroundDropdown={`bg-white`}
              textColor="text-black"
              width="w-36"
              positionDropdown={`top-10`}
              onClickItem={onChangeSearchBy}
            />
            <InputSearch
              placeholder={`필터 선택 후, 검색`}
              isMagnifyingGlass={false}
            />
          </div>
          <div className="flex items-center">
            <h1 className="font-bold text-[12px] mr-5 ml-4">기간</h1>
            <InputDate />
            <span className="mx-2 text-secondary-grey">-</span>
            <InputDate />
          </div>
        </div>
      </div>
      <div className="py-4 mr-1">
        <Button
          text={`필터 검색`}
          width="w-28"
          borderColor="border-secondary-grey border"
          textColor="black"
          paddingButton="py-1"
        />
        <Button
          text={`필터 초기화`}
          width="w-28"
          borderColor="border-secondary-grey border"
          textColor="black"
          paddingButton="py-1"
        />
      </div>
    </div>
  );
};

export default OrderExchangeFilter;
